(function(angular, module) {var ReportLinkController, reportLinkComponent;

ReportLinkController = function($scope) {
  'ngInject';
  if (this.program) {
    console.log(this.program);
    this.linkParams = angular.extend({}, this.params, {
      slug: this.program.slug
    });
    return this.location = 'program.reports.' + this.reportId;
  } else {
    this.linkParams = this.params;
    return this.location = 'reports.' + this.reportId;
  }
};

reportLinkComponent = {
  controller: ReportLinkController,
  controllerAs: '$ctrl',
  template: "<a ui-sref='{{$ctrl.location}}($ctrl.linkParams)'><ng-transclude /></a>",
  transclude: true,
  bindings: {
    program: '=',
    reportId: '@',
    params: '=?'
  }
};

module.component('reportLink', reportLinkComponent);
})(angular, angular.module("dybReports"));